import { render, staticRenderFns } from "./EsFooter.vue?vue&type=template&id=3701c722&scoped=true&"
import script from "./EsFooter.vue?vue&type=script&lang=js&"
export * from "./EsFooter.vue?vue&type=script&lang=js&"
import style0 from "./EsFooter.vue?vue&type=style&index=0&id=3701c722&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3701c722",
  null
  
)

export default component.exports